import React, { useState } from 'react'
import Card from '../nura/card/card'
import Modal from '../modal/modal'
import Button from '../nura/button/button'
import BaseForm from "../base-form/base-form"

import styles from './styles.module.css'
import { useSnackbar } from '../snackbar/snackbar'

export default function CreateProject({ onClose, show, onSubmit }) {
    const [tempValue, setTempValue] = useState("")
    const [error, setError] = useState(null)

    const handleOnCreate = () => {
        if (!tempValue.name || tempValue.name === "") {
            setError("Name is required")
            return
        }
        setError(null)
        onSubmit(tempValue)
    }

    return (
        <Modal show={show} onClose={onClose}>
            <Card variant="modal" style={{ minWidth: 358 }}>
                <BaseForm onBack={onClose} title="Create Project">
                    <div className={styles.menuDescription}>
                        <div>Create a project with the following settings</div>
                    </div>
                    <div className={styles.textAreaContainer} styles={{ marginBottom: 5 }}>
                        <div className={styles.textAreaLabel}>Name</div>
                        <input
                            name="name"
                            className={styles.textArea}
                            rows={5}
                            onChange={({ target: { value, name } }) => setTempValue((prev) =>({...prev, [name]: value }) )}
                        />
                            {error && <div className={styles.error}>{error}</div>}
                        <div/>
                    </div>
                    <div className={styles.actionGroup}>
                        <Button style={{ width: '100%' }} variant="primary" onClick={handleOnCreate}>Create</Button>
                    </div>
                </BaseForm>
            </Card>
        </Modal>
    )
}